import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import { SelectBox } from 'cbc-shared-lib';

import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';

@Component({
  selector: 'app-sgkd002d-select-pay-info',
  templateUrl: './sgkd002d-select-pay-info.component.html',
  styleUrl: './sgkd002d-select-pay-info.component.scss'
})
export class Sgkd002dSelectPayInfoComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  @Input() mainForm: UntypedFormGroup;
  /** 支払方法コードリスト */
  @Input() codePayMethodList: SelectBox[];
  /** 預金種別コードリスト */
  @Input() codeDptClsfyCdList: SelectBox[];
  /** 受取方法コードリスト */
  @Input() codeRecivMethodList: SelectBox[];
  /** クレ企業名コードリスト */
  @Input() codeCreComAnameList: SelectBox[];
  /** 業務日付 */
  @Input() businessDate: string;

  /** リスト選択検知イベント */
  @Output() changePayMethodEvent = new EventEmitter();

  /** 初期化フラグ */
  initialized: boolean = false;

  constructor() {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd002dSelectPayInfoComponent
   */
  ngOnInit(): void {
    this.mainForm.addControl(
      "selectedPayMethod",
      new UntypedFormControl(
        { value: '', disabled: false },
        [ Validators.required ]
      )
    );
    this.initialized = true;
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd002dSelectPayInfoComponent
   */
  ngOnDestroy() {
    this.mainForm.removeControl("selectedPayMethod");
    this.onDestroy$.next();
  }

  /**
   * 支払方法が口座振替か判定
   * 
   * @returns - 支払方法が口座振替の場合true
   * @memberof Sgkd002dSelectPayInfoComponent
   */
  isKouza(selectedPayMethod: string): boolean {
    return SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA == selectedPayMethod;
  }

  /**
   * 支払方法がクレジットか判定
   * 
   * @returns - 支払方法がクレジットの場合true
   * @memberof Sgkd002dSelectPayInfoComponent
   */
  isCrd(selectedPayMethod: string): boolean {
    return SgKdConstants.CODE.PAYMETHOD.USER_CODE.CRD == selectedPayMethod;
  }

  /**
   * 支払方法がＳＭＳ決済か判定
   * 
   * @returns - 支払方法がＳＭＳ決済の場合true
   * @memberof Sgkd002dSelectPayInfoComponent
   */
  isSms(selectedPayMethod: string): boolean {
    return SgKdConstants.CODE.PAYMETHOD.USER_CODE.SMS == selectedPayMethod;
  }

  /**
   * 支払方法変更イベント
   *
   * @memberof Sgkd002dSelectPayInfoComponent
   */
  onChangePayMethod(): void {
    this.changePayMethodEvent.emit();
  }

  /**
   * メッセージ領域のクリア
   * 
   * @memberof Sgkd004dComponent
   */
  clearMessage(): void {
    this.changePayMethodEvent.emit();
  }
}
